import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useCheckoutContext } from '../../core/hooks/useCheckoutContext'
import { useGatewayContext } from '../../core/contexts/GatewayContext'
import CountrySelect from './CountrySelect'

/**
 * País de cobrança, no bloco de pagamento: é ele que define os meios de pagamento
 * (Stripe etc.). Só aparece quando o produto tem venda internacional ligada.
 */
const BillingCountrySelect = () => {
  const { productPrice } = useCheckoutContext()
  const { buyerCountry, setBuyerCountry } = useGatewayContext()
  const { t } = useTranslation()

  if (productPrice?.internationalSalesEnabled !== true) return null

  return (
    <Box sx={{ mt: 2, mb: 2 }} data-testid="billingCountry">
      <CountrySelect
        value={buyerCountry}
        onChange={setBuyerCountry}
        label={t('country.billingLabel')}
      />
    </Box>
  )
}

export default BillingCountrySelect
